import { Component, inject, OnInit, signal } from '@angular/core';
import { Wk8WordService } from '@features/wk8/core/wk8-words/wk8-word-service.service';
import { Wk8WisselklankenComponent } from '@features/wk8/mechanics/wk8-wisselklanken/wk8-wisselklanken.component';
import { LpWoordData } from '@typings/lp/generated';

@Component({
  selector: 'app-test-page-casino',
  imports: [Wk8WisselklankenComponent],
  templateUrl: './test-page-casino.component.html',
  styleUrl: './test-page-casino.component.css',
})
export class TestPageCasinoComponent implements OnInit {
  readonly #wk8WordService = inject(Wk8WordService);

  word = signal<LpWoordData | undefined>(undefined);

  async ngOnInit(): Promise<void> {
    this.word.set(await this.#wk8WordService.tryFindWord('appel'));
  }
}
